import { render } from "./csrfInput.vue?vue&type=template&id=0bd6c231"
import script from "./csrfInput.vue?vue&type=script&lang=js"
export * from "./csrfInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__